<div class="row col-12 col-sm-12 mt-4 my-account-container">
  <div class="col-3 col-sm-3 col-md-3 my-account-left-nav"></div>
  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <div class="my-section-box">
      @if (true) {
      <form [formGroup]="dtcSearchForm">
        <div class="warranty-claim-application-block">
          <h1 class="warranty-claim-headling m-0">
            {{'DTC_PAGE.dtc_Form_title'|cxTranslate}}
          </h1>
          <div class="warranty-claim-application-detail">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="form-group">
                  <label class="control-label selectLabel" for="typeOfOperation">
                    {{'DTC_PAGE.product_type'|cxTranslate}}*
                  </label>
                  <div class="control select">
                    <select class="form-control" formControlName="dtcComponent">
                      <option disabled selected value="null">{{ 'common.form_select_empty' |
                        cxTranslate
                        }}</option>
                      @for (x of ( dtcComponent$ | async ); track x) {
                      <option [value]="x.value">{{
                        x.value }}</option>
                      }
                    </select>
                  </div>
                  @if ((submitted||dtcSearchForm.controls.dtcComponent.dirty) &&
                  dtcSearchForm.controls.dtcComponent.errors) {
                  <p class="dtc-error">
                    Please select component</p>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="form-group">
                  <label class="control-label selectLabel" for="dtcType">
                    {{'DTC_PAGE.dtc_type'|cxTranslate}}
                    <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info"
                      (click)="openPopupCompanyName()" />
                  </label>
                  <div class="control select">
                    <select class="form-control" formControlName="dtcType">
                      <option disabled selected value="null">{{ 'common.form_select_empty' |
                        cxTranslate
                        }}</option>
                      @for (x of ( dtcType$ | async ); track x) {
                      <option [value]="x.value">{{
                        x.value
                        }}</option>
                      }
                    </select>
                  </div>
                  @if ((submitted||dtcSearchForm.controls.dtcType.dirty) && dtcSearchForm.controls.dtcType.errors&&
                  dtcSearchForm.controls.dtcComponent.value) {
                  <p class="dtc-type-error dtc-error">
                    Please select DTC Type</p>
                  }
                </div>
              </div>
            </div>
            @if (dtcTypeValue=='SPN/FMI') {
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label selectLabel" for="spn">
                    {{'DTC_PAGE.search_string'|cxTranslate}}
                  </label>
                  <div class="control">
                    <input #searchInput type="text" formControlName="spn" [placeholder]="'SPN*'">
                  </div>
                  @if ((submitted||dtcSearchForm.controls.spn.dirty) && dtcSearchForm.controls.spn.errors) {
                  <p class="dtc-error">
                    Please enter SPN</p>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label selectLabel" for="fmi"> </label>
                  <div class="control mrgnTop">
                    <input #searchInput type="text" formControlName="fmi" [placeholder]="'FMI*'">
                  </div>
                  @if ((submitted||dtcSearchForm.controls.fmi.dirty) && dtcSearchForm.controls.fmi.errors) {
                  <p class="dtc-error">
                    Please enter FMI</p>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label selectLabel" for="internalCode1">
                    {{'DTC_PAGE.internalCodesOptional'|cxTranslate}}
                  </label>
                  <div class="control">
                    <input #searchInput type="text" formControlName="internalCode1" placeholder="Code 1 (Path)">
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label selectLabel" for="internalCode2"> </label>
                  <div class="control mrgnTop">
                    <input #searchInput type="text" formControlName="internalCode2" placeholder="Code 2 (Type)">
                  </div>
                </div>
              </div>
            </div>
            }
            @if (dtcTypeValue=='Blink Code') {
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label selectLabel" for="blinkcode1">
                    {{'DTC_PAGE.search_string'|cxTranslate}}
                  </label>
                  <div class="control">
                    <input #searchInput type="text" formControlName="blinkcode1" [placeholder]="'Blink Code 1*'">
                  </div>
                  @if ((submitted||dtcSearchForm.controls.blinkcode1.dirty) && dtcSearchForm.controls.blinkcode1.errors)
                  {
                  <p class="dtc-error">
                    Please enter Blink code 1</p>
                  }
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                <div class="form-group">
                  <label class="control-label selectLabel" for="blinkcode2"> </label>
                  <div class="control mrgnTop">
                    <input #searchInput type="text" formControlName="blinkcode2" [placeholder]="'Blink Code 2*'">
                    @if ((submitted||dtcSearchForm.controls.blinkcode2.dirty) &&
                    dtcSearchForm.controls.blinkcode2.errors ) {
                    <p class="dtc-error">
                      Please enter Blink code 2 </p>
                    }
                  </div>
                </div>
              </div>
            </div>
            }
            @if (dtcTypeValue=='Hex Code') {
            <div class="hex-continer">
              <div class="form-group">
                <label class="control-label selectLabel" for="blinkcode1">
                  {{'DTC_PAGE.search_string'|cxTranslate}}
                </label>
                <div class="control">
                  <input #searchInput type="text" formControlName="hexcode" [placeholder]="'Hex Code*'">
                </div>
                @if ((submitted||dtcSearchForm.controls.hexcode.dirty) && dtcSearchForm.controls.hexcode.errors) {
                <p class="dtc-error">
                  Please enter Hex Code</p>
                }
              </div>
            </div>
            }
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 dtc-btnBlock"> </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 dtc-btnBlock">
                <label class="control-label selectLabel" for="typeOfOperation">
                </label>
                <button type="button" id="steeringReset" class="btn btn-primary steeringReset yellow-btn"
                  name="steeringReset" (click)="dtcSearchFormreset()">{{'DTC_PAGE.reset'|cxTranslate}}</button>
                <button type="type" class="btn btn-primary-new yellow-btn steering-submit" id="finalSubmit"
                  (click)="onSubmit()">{{'DTC_PAGE.search'|cxTranslate}}
                  <img src="/icons/link-grey.svg" alt="Link Icon"></button>
              </div>
            </div>
          </div>
        </div>
      </form>
      }


      @if (dtcDatabottomSection) {
      <div class="bottomSectionPDP">
        <section class="cx-page-section">
          @if (dtcData$|async; as dtcDataCopy) {
          <div class="container1">
            @if (dtcHasResult.length>0) {
            <div class="row1">
              @if (viewMode$ | async; as viewMode) {
              <div class="">
                <div class="cx-sorting top">
                  <div class="action-row sorting-block">
                    <label class="d-lg-block col-md-2 col-lg-3 total-records mb-0">{{dtcHasResult.length}}
                      {{'common.search_page_totalResults'|cxTranslate}}</label>
                    <div class="sort-select col-md-10 col-lg-7">
                      <label class="sort-by dtc-sortby">
                        <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                      </label>
                      <div class="col-lg-6 sorting">
                        <select id="pdp-select-part" name="sort" class="form-control pdp-select pdp-part-sort"
                          [formControl]="sortControl" (change)="sortControlValueChanged($event,dtcHasResult)">
                          <option value='typeName_asc' [selected]="true">{{'DTC_PAGE.dtcTypeAscending'|cxTranslate}}
                          </option>
                          <option value='typeName_desc'>{{'DTC_PAGE.dtcTypeDescending'|cxTranslate}}
                          </option>
                          <option value='productType_asc'>{{'DTC_PAGE.productTypeAscending'|cxTranslate}}</option>
                          <option value='productType_desc'>{{'DTC_PAGE.productTypeDescending'|cxTranslate}}</option>
                        </select>
                      </div>
                    </div>
                    @if (!isMobile) {
                    <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn">
                      <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                    </div>
                    }
                  </div>
                </div>
                <div id="product-results-list" class="cx-product-container">
                  <!-- Product list when using pagination -->
                  @if (!isInfiniteScroll) {
                  @if (viewMode === ViewModes.Grid) {
                  <div class="row">
                    @for (product of dtcHasResult; track product) {
                    <app-dtc-search-grid [product]="product"
                      class="col-12 col-sm-12 col-md-12 col-lg-3"></app-dtc-search-grid>
                    }
                  </div>
                  }
                  @if (viewMode === ViewModes.List) {
                  @for (product of dtcHasResult; track product) {
                  <app-dtc-search-list [product]="product" class="cx-product-search-list">
                  </app-dtc-search-list>
                  }
                  }
                  } @else {
                  <cx-product-scroll [scrollConfig]="scrollConfig" [model]="dtcHasResult"
                    [inputViewMode]="viewMode"></cx-product-scroll>
                  }
                  <!-- Product list when using infinite scroll -->
                </div>
              </div>
              }
            </div>
            } @else {
            <div class="document-not-found">{{'common.text_account_core_search_noRequestFound'|cxTranslate}}
            </div>
            }
          </div>
          }
        </section>
      </div>
      }
    </div>
  </div>
</div>
<!-- Popup for contactName -->
@if (popupOpenCompanyName) {
<div class="popup-backdrop"></div>
}

@if (popupOpenCompanyName) {
<div class="popup-modal">
  <div class="popup-header">
    <button class="close-btn" aria-label="close dialog" (click)="closePopupCompanyName()">
      <img src="/icons/close-light-grey.svg" alt="" />
    </button>
  </div>
  <div class="popup-body">
    <span class="popup-title">{{'DTC_PAGE.dtc_popup_title'|cxTranslate}}</span>
    <p class="mt-3" [innerHTML]="'DTC_PAGE.spn_text' | cxTranslate"></p>
    <p class="mt-3" [innerHTML]="'DTC_PAGE.fmi_text' | cxTranslate"></p>
    <p class="mt-3" [innerHTML]="'DTC_PAGE.hex_code_text' | cxTranslate"></p>
    <p class="mt-3" [innerHTML]="'DTC_PAGE.blink_codes_text' | cxTranslate"></p>
  </div>
</div>
}